import React from 'react';
import './TechnicianCard.css';

interface TechnicianCardProps {
  name: string;
  rating: number;
  eta: string;
  phoneNumber: string;
  vehicleInfo: string;
  style?: React.CSSProperties;
}

export const TechnicianCard: React.FC<TechnicianCardProps> = ({
  name,
  rating,
  eta,
  phoneNumber,
  vehicleInfo,
  style,
}) => {
  const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i
          key={i}
          className={`fas fa-star ${i <= rating ? 'filled' : 'empty'}`}
        />
      );
    }
    return stars;
  };

  return (
    <div className="technician-card" style={style}>
      <div className="card-header">
        <div className="technician-info">
          <h3 className="technician-name">{name}</h3>
          <div className="rating-container">
            {renderStars(rating)}
            <span className="rating-text">({rating})</span>
          </div>
        </div>
        <div className="eta-container">
          <span className="eta-label">ETA</span>
          <span className="eta">{eta}</span>
        </div>
      </div>
      
      <div className="card-details">
        <div className="detail-row">
          <i className="fas fa-phone"></i>
          <span className="detail-text">{phoneNumber}</span>
        </div>
        <div className="detail-row">
          <i className="fas fa-car"></i>
          <span className="detail-text">{vehicleInfo}</span>
        </div>
      </div>
    </div>
  );
};
